module.exports = __webpack_public_path__ + "img/home_sleeping.5438eac1.jpg";